<script setup lang="ts">
import { reactive, ref } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import { sectionsApi } from '@/services/api/sections';

const route = useRoute();
const router = useRouter();
const form = reactive({
  section_num: 0,
  name: 'Section Name',
  display_name: 'Display Name',
});
const submitting = ref(false);

function ids(): { projectId: string; formId: string } {
  const p = route.params.id;
  const f = route.params.form_id;
  return {
    projectId: Array.isArray(p) ? (p[0] ?? '') : p ?? '',
    formId: Array.isArray(f) ? (f[0] ?? '') : f ?? '',
  };
}

async function submit(): Promise<void> {
  if (submitting.value) return;
  submitting.value = true;
  try {
    const { projectId, formId } = ids();
    const created = await sectionsApi.create(projectId, formId, form);
    await router.replace({
      name: 'projectSectionsEdit',
      params: { id: projectId, form_id: formId, section_id: String(created.id) },
    });
  } finally {
    submitting.value = false;
  }
}
</script>

<template>
  <section class="resource">
    <h1>New Section</h1>
    <form class="resource__form" @submit.prevent="submit">
      <label><span>Name</span><input v-model="form.name" type="text" required /></label>
      <label><span>Display Name</span><input v-model="form.display_name" type="text" /></label>
      <label><span>Section Number</span><input v-model.number="form.section_num" type="number" /></label>
      <button type="submit" :disabled="submitting">Create Section</button>
    </form>
  </section>
</template>

<style scoped src="@/assets/styles/resource-list.scss"></style>
<style scoped>
.resource__form {
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
  max-width: 32rem;
}
.resource__form input {
  width: 100%;
  padding: 0.5rem 0.75rem;
  border: 1px solid #d1d5db;
  border-radius: 0.375rem;
}
.resource__form button {
  align-self: flex-start;
  padding: 0.5rem 1rem;
  background: #2563eb;
  color: #fff;
  border: 0;
  border-radius: 0.375rem;
  cursor: pointer;
}
</style>
